<template>
  <div class="home">
    <div class="left-side">

      <section id="home">
        <div class="bg">
          <img src="@/assets/img/circle-img1.png" alt="">
        </div>
        <div class="center">
          <h1>
            <span class="big scrolled js-scroll fade-in-bottom delay-fade1">Farmak</span>
            <br>
            <span class="bottom">
            <span class="line-wrapper">
              <span class="line1 scrolled js-scroll width-animation delay-width1"></span>
              <span class="line2 scrolled js-scroll width-animation delay-width2"></span>
              <span class="line3 scrolled js-scroll width-animation delay-width3"></span>
              <span class="line4 scrolled js-scroll width-animation delay-width4"></span>
            </span>
              <span class="small m-l scrolled js-scroll fade-in-bottom delay-fade2">FZ-LLC</span>
            </span>
          </h1>
          <h3 class="scrolled js-scroll fade-in-bottom delay-fade3">
            a company in the Farmak Group
          </h3>

          <h2 class="scrolled js-scroll fade-in-bottom delay-fade4">
            FARMAK IS A THRIVING<br>
            <span class="mr1"></span>INTERNATIONAL
            <br>
            <span class="mr2"></span>PHARMACEUTICAL COMPANY
            <br>
            FOCUSED ON <span class="color">SPECIALTY GENERICS</span>
          </h2>

        </div>
        <p class="scroll-down" @click="next()">
          <svg viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.44015 0H4.93235V12.1843L1.06618 8.31816L0 9.38434L4.62013 14.0045L4.6201 14.0045L5.68628 15.0707L11.3726 9.3844L10.3064 8.31823L6.44015 12.1845V0Z"
                  fill="#009EE0"/>
          </svg>
          scroll down
        </p>
      </section>

      <section id="news">
        <div class="content news js-scroll fade-in-bottom">
          <h2 class="news__title">News</h2>
          <p class="news__subTitle">On July 10, 2024, Farmak had the honour of hosting Mr. Kazem Tarek Adil, the Chargé d'Affaires of the Republic of Iraq to Ukraine, at our production plant in Kyiv. During the tour, we
            showcased the cutting-edge technologies and processes involved in the production and packaging of our
            medicines in Ukraine</p>
          <p class="news__text">Farmak prides itself on operating with openness and transparency. We are always ready to
            demonstrate our production processes and infrastructure to assure our partners that we adhere to the highest
            international standards. Despite challenges during the war, our commitment to pharmaceutical excellence
            remains unwavering</p>
          <p class="news__text">As Farmak continues to expand its export potential, particularly in the Middle East
            markets, we are proud to be a reliable partner for many countries in the region, meeting their needs for
            modern and effective medicines. Our products contribute to the health and well-being of patients in nearly
            60 countries worldwide</p>
          <p class="news__text news__text--last">Worth mentioning that we are represented by <a
              href="https://esb.group/"
              target="_blank">our
            partner ESB
            in Iraq</a> and honoured to serve Iraqian patients with our quality brands</p>

          <p class="news__subTitle news__subTitle--arabic news__subTitle--mt">فرماك يقوم بجولة في الإنتاج للقائم بأعمال
            جمهورية العراق في أوكرانيا</p>
          <p class="news__text news__text--arabic">في 10 تموز/يوليو٢٠٢٤، تشرفت فرماك باستضافة السيد كاظم طارق عادل،
            القائم بأعمال جمهورية العراق لدى أوكرانيا، في مصنع الإنتاج الخاص بنا في كييف. خلال الجولة ، عرضنا التقنيات
            والعمليات المتطورة التي ينطوي عليها إنتاج وتعبئة أدويتنا في أوكرانيا</p>
          <p class="news__text news__text--arabic">تفخر فرماك بالعمل بانفتاح وشفافية. نحن دائما على استعداد لإظهار
            عمليات الإنتاج والبنية التحتية لدينا لنؤكد لشركائنا أننا نلتزم بأعلى المعايير الدولية. على الرغم من انقطاع
            التيار الكهربائي والتحديات الأخرى خلال الحرب ، لا يزال التزامنا بالتميز الصيدلاني ثابتا</p>
          <p class="news__text news__text--last news__text--arabic">ومع استمرار "فارماك" في توسيع إمكاناتها التصديرية،
            لا سيما في أسواق
            الشرق الأوسط، فإننا فخورون بالمشاركة بأننا شريك موثوق به للعديد من البلدان في المنطقة، ونلبي احتياجاتها من
            الأدوية الحديثة والفعالة. تساعد منتجاتنا الصيدلانية في دعم وحماية صحة المرضى في حوالي 60 دولة حول العالم -
            ويستمر هذا العدد في النمو</p>
        </div>
      </section>

      <section id="values">
        <div class="content js-scroll fade-in-bottom">
          <h2 class="">VALUES</h2>

          <div class="button-wrapper ">
            <div class=" item item1">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>QUALITY</p>
            </div>
            <div class=" item item2">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>PARTNERSHIP</p>
            </div>
            <div class=" item item3">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>INNOVATIONS</p>
            </div>
            <div class=" item item4">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>EXPANSION</p>
            </div>
            <div class=" item item5">
              <svg width="33" height="5" viewBox="0 0 33 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="26" height="4" transform="matrix(1 0 0 -1 0 4.5)" fill="#009EE0"/>
                <rect width="4" height="4" transform="matrix(1 0 0 -1 29 4.5)" fill="#009EE0"/>
              </svg>

              <p>SUSTAINABILITY</p>
            </div>
          </div>

          <div class="our-mission ">
            <div class="blue">
              <h3>Our mission</h3>
              <p>Providing easy access to effective, high-quality medicines to contribute to the health of society</p>
            </div>
            <div class="line1 line js-scroll width-animation2 delay-width1"></div>
            <div class="line2 line js-scroll width-animation2 delay-width2"></div>
            <div class="line3 line js-scroll width-animation2 delay-width3"></div>
          </div>

          <div class="purpose ">
            <div class="line1 line js-scroll width-animation2 delay-width3"></div>
            <div class="line2 line js-scroll width-animation2 delay-width2"></div>
            <div class="line3 line js-scroll width-animation2 delay-width1"></div>
            <div class="white">
              <h3>PURPOSE & AMBITION</h3>
              <p>Become a strong global partner in the specialty care sector while maintaining high standards of
                quality, innovation, and social responsibility</p>
            </div>
          </div>

        </div>
      </section>

      <section id="mea-region">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">MEA region</h2>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M39.2015 76.961C38.3146 77.2034 37.3811 77.3328 36.4173 77.3328H32.4294C26.6122 77.3328 21.8965 72.6171 21.8965 66.7999V44.9772C21.8965 39.16 26.6122 34.4443 32.4294 34.4443H36.4173C42.2345 34.4443 46.9502 39.16 46.9502 44.9772V53.89"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M86.4414 53.9777H39.3064V77.3328H86.4414V53.9777Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path d="M86.4414 53.9777H39.3064V65.4429H86.4414V53.9777Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M54.7161 24.0406H72.4125C74.5014 24.0406 76.1973 25.7365 76.1973 27.8254V53.9777H50.9313V27.8254C50.9313 25.7365 52.6272 24.0406 54.7161 24.0406Z"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M42.2792 13H26.5675V34.4443H42.2792V13Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path d="M16.5885 28.0746H26.5675V16.6094H16.5885V28.0746Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path d="M16.5886 57.1625H18.7118L18.7118 28.0747H16.5886L16.5886 57.1625Z" stroke="#009EE0"
                        stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M16.6946 42.7247H3V74.3604H24.8689" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M60.9102 30.941C60.9102 32.4654 59.6744 33.7012 58.15 33.7012C56.6257 33.7012 55.3899 32.4654 55.3899 30.941C55.3899 29.4166 56.6257 28.1808 58.15 28.1808C59.6744 28.1808 60.9102 29.4166 60.9102 30.941ZM68.9784 33.7012C70.5027 33.7012 71.7385 32.4654 71.7385 30.941C71.7385 29.4166 70.5027 28.1808 68.9784 28.1808C67.454 28.1808 66.2182 29.4166 66.2182 30.941C66.2182 32.4654 67.454 33.7012 68.9784 33.7012ZM58.15 36.5675C56.6257 36.5675 55.3899 37.8032 55.3899 39.3276C55.3899 40.852 56.6257 42.0878 58.15 42.0878C59.6744 42.0878 60.9102 40.852 60.9102 39.3276C60.9102 37.8032 59.6744 36.5675 58.15 36.5675ZM68.9784 36.5675C67.454 36.5675 66.2182 37.8032 66.2182 39.3276C66.2182 40.852 67.454 42.0878 68.9784 42.0878C70.5027 42.0878 71.7385 40.852 71.7385 39.3276C71.7385 37.8032 70.5027 36.5675 68.9784 36.5675ZM58.15 44.9541C56.6257 44.9541 55.3899 46.1899 55.3899 47.7143C55.3899 49.2386 56.6257 50.4744 58.15 50.4744C59.6744 50.4744 60.9102 49.2386 60.9102 47.7143C60.9102 46.1899 59.6744 44.9541 58.15 44.9541ZM68.9784 44.9541C67.454 44.9541 66.2182 46.1899 66.2182 47.7143C66.2182 49.2386 67.454 50.4744 68.9784 50.4744C70.5027 50.4744 71.7385 49.2386 71.7385 47.7143C71.7385 46.1899 70.5027 44.9541 68.9784 44.9541Z"
                      fill="#009EE0"/>
                </svg>

              </div>
              <p class="text">
                <span class="big">Middle East and Africa (MEA) region</span>
                is a continuation of our decentralized model and supporting our vision to provide <span class="color">the best service
                to our partners.</span>
              </p>
            </div>
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M6.0328 38.6138C6.34215 39.0714 6.96382 39.1915 7.42133 38.8821L14.877 33.841C15.3345 33.5316 15.4546 32.91 15.1453 32.4525C14.8359 31.9949 14.2143 31.8748 13.7567 32.1842L7.12949 36.6652L2.64848 30.0379C2.33913 29.5804 1.71746 29.4603 1.25995 29.7697C0.802428 30.079 0.682315 30.7007 0.991664 31.1582L6.0328 38.6138ZM21.656 14.44L22.255 15.2407L21.656 14.44ZM48.4867 6.91573L48.582 5.92028L48.4867 6.91573ZM73.4027 19.3932L74.1428 18.7206L73.4027 19.3932ZM7.84305 38.2434C9.61925 29.0504 14.7576 20.8492 22.255 15.2407L21.057 13.6392C13.1613 19.5457 7.74994 28.1826 5.87936 37.864L7.84305 38.2434ZM22.255 15.2407C29.7525 9.63222 39.0709 7.01901 48.3914 7.91118L48.582 5.92028C38.7663 4.98071 28.9528 7.73276 21.057 13.6392L22.255 15.2407ZM48.3914 7.91118C57.7118 8.80334 66.3653 13.1368 72.6627 20.0658L74.1428 18.7206C67.5108 11.4236 58.3976 6.85984 48.582 5.92028L48.3914 7.91118ZM72.6627 20.0658C78.9601 26.9947 82.4493 36.0217 82.4493 45.3848H84.4493C84.4493 35.5243 80.7747 26.0177 74.1428 18.7206L72.6627 20.0658Z"
                      fill="#009EE0"/>
                  <path
                      d="M83.2016 52.1557C82.8922 51.6982 82.2706 51.5781 81.813 51.8875L74.3574 56.9286C73.8999 57.2379 73.7797 57.8596 74.0891 58.3171C74.3984 58.7746 75.0201 58.8948 75.4776 58.5854L82.1049 54.1044L86.5859 60.7317C86.8952 61.1892 87.5169 61.3093 87.9744 60.9999C88.4319 60.6906 88.5521 60.0689 88.2427 59.6114L83.2016 52.1557ZM67.5783 76.3296L66.9793 75.5289L67.5783 76.3296ZM40.7477 83.8539L40.6524 84.8493L40.7477 83.8539ZM15.8316 71.3764L15.0916 72.049L15.8316 71.3764ZM81.3913 52.5262C79.6151 61.7192 74.4768 69.9204 66.9793 75.5289L68.1773 77.1304C76.0731 71.2239 81.4844 62.587 83.355 52.9056L81.3913 52.5262ZM66.9793 75.5289C59.4819 81.1374 50.1635 83.7506 40.843 82.8584L40.6524 84.8493C50.4681 85.7889 60.2816 83.0368 68.1773 77.1304L66.9793 75.5289ZM40.843 82.8584C31.5225 81.9663 22.869 77.6328 16.5717 70.7038L15.0916 72.049C21.7236 79.346 30.8368 83.9098 40.6524 84.8493L40.843 82.8584ZM16.5717 70.7038C10.2743 63.7749 6.78509 54.7479 6.78509 45.3848H4.78509C4.78509 55.2453 8.45969 64.7519 15.0916 72.049L16.5717 70.7038Z"
                      fill="#009EE0"/>
                  <path
                      d="M63.8074 45.3848C63.8074 56.1653 61.5918 65.8758 58.0567 72.8542C54.4932 79.8888 49.7523 83.8715 44.8047 83.8715C39.857 83.8715 35.1161 79.8888 31.5526 72.8542C28.0176 65.8758 25.8019 56.1653 25.8019 45.3848C25.8019 34.6042 28.0176 24.8938 31.5526 17.9154C35.1161 10.8808 39.857 6.89807 44.8047 6.89807C49.7523 6.89807 54.4932 10.8808 58.0567 17.9154C61.5918 24.8938 63.8074 34.6042 63.8074 45.3848Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M75.8517 22.9138C72.858 24.6098 68.5394 26.0658 63.2601 27.1165C57.9917 28.165 51.9853 28.7663 45.7964 28.8604C39.608 28.9545 33.4526 28.5383 27.9004 27.6529C22.3411 26.7664 17.6022 25.4439 14.1019 23.8289"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M75.8517 67.8556C72.858 66.1597 68.5394 64.7036 63.2601 63.653C57.9917 62.6045 51.9853 62.0032 45.7964 61.909C39.608 61.8149 33.4526 62.2312 27.9004 63.1165C22.3411 64.003 17.6022 65.3255 14.1019 66.9405"
                      stroke="#009EE0" stroke-width="2"/>
                  <line x1="5.00024" y1="44.3848" x2="84.2909" y2="44.3848" stroke="#009EE0" stroke-width="2"/>
                  <line x1="43.8043" y1="84.8715" x2="43.8043" y2="6.7398" stroke="#009EE0" stroke-width="2"/>
                </svg>

              </div>
              <p class="text">
                We provide medicines to multiple countries
                in the region (e.g. <span class="big">UAE, Saudi Arabia,
Iraq, Yemen, Libya, South Africa, Pakistan</span>).
              </p>
            </div>
          </div>

        </div>
      </section>

      <section id="focus">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">Focus</h2>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.4886 19.5009L4.76123 67.0388" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M66.5107 19.5009L85.2381 67.0388" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M16.4453 67.131V56.6487C16.4453 55.1938 17.6247 54.0144 19.0796 54.0144H21.681C23.1359 54.0144 24.3153 55.1938 24.3153 56.6487V67.131"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M24.3154 49.3731H16.4454V53.409H24.3154V49.3731Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M28.7543 67.131V56.6487C28.7543 55.1938 29.9337 54.0144 31.3886 54.0144H33.9899C35.4448 54.0144 36.6242 55.1938 36.6242 56.6487V67.131"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M36.6243 49.3732H28.7544V53.409H36.6243V49.3732Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M41.0653 67.131V56.6487C41.0653 55.1938 42.2447 54.0144 43.6996 54.0144H46.301C47.7559 54.0144 48.9353 55.1938 48.9353 56.6487V67.131"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M48.9351 49.3732H41.0652V53.409H48.9351V49.3732Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M53.3744 67.131V56.6487C53.3744 55.1938 54.5538 54.0144 56.0087 54.0144H58.6101C60.0649 54.0144 61.2443 55.1938 61.2443 56.6487V67.131"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M61.2442 49.3732H53.3743V53.409H61.2442V49.3732Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M65.6835 67.131V56.6487C65.6835 55.1938 66.8629 54.0144 68.3178 54.0144H70.9191C72.374 54.0144 73.5534 55.1938 73.5534 56.6487V67.131"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M73.5533 49.3732H65.6833V53.409H73.5533V49.3732Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M22.6504 49.575V42.5467C22.6504 41.0951 23.8271 39.9184 25.2787 39.9184H27.8743C29.3259 39.9184 30.5026 41.0951 30.5026 42.5467V49.575"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M30.5027 35.4894H22.6505V39.3144H30.5027V35.4894Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M34.9321 49.575V42.5467C34.9321 41.0951 36.1089 39.9184 37.5605 39.9184H40.156C41.6076 39.9184 42.7844 41.0951 42.7844 42.5467V49.575"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M42.7844 35.4894H34.9321V39.3144H42.7844V35.4894Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M47.2141 49.575V42.5467C47.2141 41.0951 48.3909 39.9184 49.8425 39.9184H52.438C53.8896 39.9184 55.0663 41.0951 55.0663 42.5467V49.575"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M55.0663 35.4894H47.2141V39.3144H55.0663V35.4894Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M59.496 49.575V42.5467C59.496 41.0951 60.6727 39.9184 62.1243 39.9184H64.7199C66.1715 39.9184 67.3482 41.0951 67.3482 42.5467V49.575"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M67.3481 35.4894H59.4958V39.3144H67.3481V35.4894Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M29.3727 35.7521V31.1953C29.3727 29.7957 30.5073 28.6611 31.9069 28.6611H34.4095C35.8091 28.6611 36.9437 29.7957 36.9437 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M36.9437 24.3907H29.3727V28.0787H36.9437V24.3907Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M41.2131 35.7521V31.1953C41.2131 29.7957 42.3477 28.6611 43.7473 28.6611H46.2499C47.6495 28.6611 48.7841 29.7957 48.7841 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M48.7844 24.3907H41.2134V28.0787H48.7844V24.3907Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path
                      d="M53.056 35.7521V31.1953C53.056 29.7957 54.1906 28.6611 55.5902 28.6611H58.0928C59.4924 28.6611 60.627 29.7957 60.627 31.1953V35.7521"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M60.6271 24.3907H53.0562V28.0787H60.6271V24.3907Z" stroke="#009EE0" stroke-width="2"
                        stroke-miterlimit="10"/>
                  <path d="M0 67.1309H90" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M0 70.965H90" stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
              </div>
              <p class="text">
                <span class="big">We plan to create and bring products</span><span class="color"> in different areas of healthcare</span>
                where it can make a real difference and we focus on local unmet needs.
              </p>
            </div>
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M74.3969 53.4369H80.1994V79.037C80.1994 80.6394 78.9005 81.9383 77.2981 81.9383C75.6958 81.9383 74.3969 80.6394 74.3969 79.037V53.4369Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M74.3969 64.5083H80.1994V79.037C80.1994 80.6394 78.9005 81.9383 77.2981 81.9383C75.6958 81.9383 74.3969 80.6394 74.3969 79.037V64.5083Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="72.864" y="50.3317" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <path
                      d="M61.6262 53.4369H67.4288V79.037C67.4288 80.6394 66.1299 81.9383 64.5275 81.9383C62.9252 81.9383 61.6262 80.6394 61.6262 79.037V53.4369Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M61.6262 64.5083H67.4288V79.037C67.4288 80.6394 66.1299 81.9383 64.5275 81.9383C62.9252 81.9383 61.6262 80.6394 61.6262 79.037V64.5083Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="60.0934" y="50.3317" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <path
                      d="M48.8556 53.6623H54.6582V79.0371C54.6582 80.6394 53.3592 81.9384 51.7569 81.9384C50.1545 81.9384 48.8556 80.6394 48.8556 79.0371V53.6623Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <path
                      d="M48.8556 64.522H54.6582V79.037C54.6582 80.6394 53.3592 81.9383 51.7569 81.9383C50.1545 81.9383 48.8556 80.6394 48.8556 79.037V64.522Z"
                      stroke="#009EE0" stroke-width="2"/>
                  <rect x="47.3228" y="50.3317" width="8.86834" height="2.65786" rx="1.32893" stroke="#009EE0"
                        stroke-width="2"/>
                  <rect x="44.4871" y="57.5476" width="38.7499" height="1.55262" stroke="#009EE0"
                        stroke-width="1.55262"/>
                  <mask id="path-11-inside-1_754_544" fill="white">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M18.4081 18.5046C17.1219 18.5046 16.0792 19.5473 16.0792 20.8336C16.0792 22.1198 17.1219 23.1625 18.4081 23.1625H29.2765C30.5627 23.1625 31.6054 22.1198 31.6054 20.8336C31.6054 19.5473 30.5627 18.5046 29.2765 18.5046H18.4081ZM28.8885 47.9511V23.1625H18.7965V47.9511C11.3926 50.1283 5.9873 56.9745 5.9873 65.0832C5.9873 74.9443 13.9813 82.9384 23.8424 82.9384C33.7036 82.9384 41.6976 74.9443 41.6976 65.0832C41.6976 56.9746 36.2924 50.1284 28.8885 47.9511Z"/>
                  </mask>
                  <path
                      d="M28.8885 23.1625H30.8885V21.1625H28.8885V23.1625ZM28.8885 47.9511H26.8885V49.4477L28.3243 49.8699L28.8885 47.9511ZM18.7965 23.1625V21.1625H16.7965V23.1625H18.7965ZM18.7965 47.9511L19.3607 49.8698L20.7965 49.4476V47.9511H18.7965ZM18.0792 20.8336C18.0792 20.6519 18.2265 20.5046 18.4081 20.5046V16.5046C16.0173 16.5046 14.0792 18.4428 14.0792 20.8336H18.0792ZM18.4081 21.1625C18.2265 21.1625 18.0792 21.0152 18.0792 20.8336H14.0792C14.0792 23.2244 16.0173 25.1625 18.4081 25.1625V21.1625ZM29.2765 21.1625H18.4081V25.1625H29.2765V21.1625ZM29.6054 20.8336C29.6054 21.0152 29.4581 21.1625 29.2765 21.1625V25.1625C31.6673 25.1625 33.6054 23.2244 33.6054 20.8336H29.6054ZM29.2765 20.5046C29.4581 20.5046 29.6054 20.6519 29.6054 20.8336H33.6054C33.6054 18.4428 31.6673 16.5046 29.2765 16.5046V20.5046ZM18.4081 20.5046H29.2765V16.5046H18.4081V20.5046ZM26.8885 23.1625V47.9511H30.8885V23.1625H26.8885ZM18.7965 25.1625H28.8885V21.1625H18.7965V25.1625ZM20.7965 47.9511V23.1625H16.7965V47.9511H20.7965ZM7.9873 65.0832C7.9873 57.8857 12.7848 51.8035 19.3607 49.8698L18.2323 46.0323C10.0003 48.453 3.9873 56.0633 3.9873 65.0832H7.9873ZM23.8424 80.9384C15.0859 80.9384 7.9873 73.8398 7.9873 65.0832H3.9873C3.9873 76.0489 12.8767 84.9384 23.8424 84.9384V80.9384ZM39.6976 65.0832C39.6976 73.8398 32.599 80.9384 23.8424 80.9384V84.9384C34.8081 84.9384 43.6976 76.0489 43.6976 65.0832H39.6976ZM28.3243 49.8699C34.9001 51.8036 39.6976 57.8858 39.6976 65.0832H43.6976C43.6976 56.0634 37.6846 48.4531 29.4528 46.0324L28.3243 49.8699Z"
                      fill="#009EE0" mask="url(#path-11-inside-1_754_544)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M46.5219 44.0496C46.385 43.9127 46.163 43.9127 46.0261 44.0496C45.8892 44.1865 45.8892 44.4085 46.0261 44.5454C46.163 44.6823 46.385 44.6823 46.5219 44.5454C46.6588 44.4085 46.6588 44.1865 46.5219 44.0496ZM45.1077 45.4638C45.7518 46.108 46.7961 46.108 47.4403 45.4638C47.9275 44.9766 48.0462 44.2604 47.7964 43.6617L49.1616 41.2971L49.1192 41.2726C49.9829 41.4243 50.9044 41.1666 51.5716 40.4994C51.9528 40.1182 52.2003 39.654 52.3142 39.165H58.7775C58.7842 39.1938 58.7915 39.2225 58.7992 39.2513C59.1761 40.658 60.5656 41.523 61.9734 41.2721L61.9305 41.2968L63.2957 43.6614C63.1597 43.9865 63.1263 44.3575 63.2245 44.7242C63.4603 45.6041 64.3647 46.1263 65.2446 45.8905C66.1246 45.6547 66.6467 44.7503 66.411 43.8704C66.2326 43.2045 65.6712 42.7435 65.0274 42.6608L63.6626 40.2968L63.6197 40.3216C64.1835 39.6494 64.4213 38.722 64.177 37.8103C64.0375 37.2894 63.759 36.8428 63.3923 36.4996L66.6242 30.9018C67.0355 31.027 67.4802 31.0582 67.9265 30.9772L70.9225 36.1664C70.7862 36.4916 70.7528 36.8627 70.8511 37.2296C71.0869 38.1095 71.9913 38.6317 72.8712 38.3959C73.7511 38.1601 74.2733 37.2557 74.0375 36.3758C73.8591 35.7101 73.298 35.2491 72.6544 35.1663L69.6362 29.9385C69.8112 29.7114 69.9506 29.4583 70.0489 29.1886V29.2376H72.7786C73.1722 29.7536 73.852 30.0091 74.5177 29.8307C75.3976 29.5949 75.9198 28.6905 75.684 27.8106C75.4483 26.9307 74.5438 26.4085 73.6639 26.6443C73.2971 26.7426 72.9924 26.9571 72.7789 27.2376H70.0489V27.2867C69.9489 27.0106 69.8086 26.7587 69.6365 26.5359L72.6544 21.3086C73.2981 21.2257 73.8591 20.7648 74.0375 20.0991C74.2733 19.2192 73.7511 18.3148 72.8712 18.079C71.9913 17.8432 71.0869 18.3654 70.8511 19.2453C70.7528 19.6122 70.7862 19.9833 70.9225 20.3085L67.9267 25.4973C67.535 25.4264 67.1219 25.4387 66.7118 25.5486C66.6824 25.5565 66.6533 25.5648 66.6244 25.5735L63.3927 19.9761C63.7602 19.6328 64.0391 19.1857 64.1788 18.6642C64.423 17.7527 64.1854 16.8257 63.6221 16.1536L63.6638 16.1776L65.0286 13.8136C65.6724 13.7309 66.2337 13.2699 66.4121 12.6041C66.6479 11.7242 66.1257 10.8197 65.2458 10.584C64.3659 10.3482 63.4615 10.8704 63.2257 11.7503C63.1275 12.117 63.1608 12.488 63.2969 12.813L61.9317 15.1776L61.9743 15.2022C60.5668 14.9519 59.1778 15.8168 58.801 17.2232C58.7932 17.2521 58.7859 17.281 58.7792 17.31H52.3128C52.199 16.8209 51.9514 16.3565 51.5702 15.9753C50.9028 15.3079 49.9808 15.0502 49.1169 15.2022L49.1596 15.1776L47.7944 12.813C48.0442 12.2142 47.9255 11.4981 47.4383 11.0109C46.7941 10.3667 45.7498 10.3667 45.1057 11.0109C44.4615 11.655 44.4615 12.6994 45.1057 13.3435C45.3743 13.6122 45.7127 13.7688 46.0625 13.8133L47.4275 16.1776L47.4702 16.153C46.5492 17.2467 46.6036 18.8824 47.6333 19.9122C47.6544 19.9332 47.6757 19.9539 47.6973 19.9741L44.4649 25.5728C44.4366 25.5643 44.4081 25.5562 44.3793 25.5485C43.9693 25.4386 43.5562 25.4262 43.1645 25.4972L40.1686 20.308C40.3046 19.983 40.338 19.612 40.2397 19.2453C40.004 18.3654 39.0995 17.8432 38.2196 18.079C37.3397 18.3148 36.8175 19.2192 37.0533 20.0991C37.2317 20.7649 37.793 21.2259 38.4369 21.3087L41.4547 26.5358C41.2827 26.7584 41.1424 27.0101 41.0425 27.286V27.2374H38.3124C38.0989 26.9569 37.7942 26.7424 37.4274 26.6441C36.5475 26.4084 35.6431 26.9306 35.4073 27.8105C35.1715 28.6904 35.6937 29.5948 36.5736 29.8306C37.2394 30.009 37.9192 29.7535 38.3128 29.2374H41.0425V29.1889C41.1408 29.4585 41.2801 29.7115 41.4551 29.9385L38.4369 35.1662C37.7931 35.249 37.2317 35.71 37.0533 36.3758C36.8175 37.2557 37.3397 38.1602 38.2196 38.3959C39.0995 38.6317 40.004 38.1095 40.2397 37.2296C40.338 36.8629 40.3046 36.492 40.1686 36.1669L43.1649 30.9772C43.6103 31.058 44.0542 31.027 44.4649 30.9023L47.6977 36.5015C47.6764 36.5215 47.6555 36.5418 47.6347 36.5625C46.6052 37.5921 46.5507 39.2273 47.471 40.321L47.4295 40.2971L46.0645 42.6614C45.7147 42.7059 45.3763 42.8625 45.1077 43.1312C44.4635 43.7753 44.4635 44.8197 45.1077 45.4638ZM49.5716 35.7474L46.0548 29.6561C46.181 29.4428 46.2805 29.209 46.3478 28.9579C46.5495 28.2049 46.4224 27.4413 46.0545 26.8195L49.5718 20.7274C50.2942 20.7351 51.019 20.4633 51.5702 19.9122C51.7538 19.7285 51.9064 19.5256 52.028 19.31L59.0645 19.31C59.419 19.9392 60.0166 20.4309 60.7694 20.6326C61.0194 20.6996 61.2706 20.7303 61.5174 20.728L65.0355 26.8216C64.6685 27.443 64.5419 28.2058 64.7434 28.958C64.8105 29.2083 64.9096 29.4414 65.0351 29.6541L61.5177 35.7464C61.2702 35.7439 61.0183 35.7747 60.7676 35.8418C60.0146 36.0436 59.4169 36.5355 59.0624 37.165H52.0296C51.908 36.9492 51.7553 36.7462 51.5716 36.5625C51.02 36.011 50.2945 35.7392 49.5716 35.7474ZM64.7282 12.5158C64.5412 12.4657 64.4302 12.2735 64.4803 12.0864C64.5304 11.8994 64.7226 11.7884 64.9097 11.8385C65.0967 11.8886 65.2077 12.0809 65.1576 12.2679C65.1075 12.4549 64.9152 12.5659 64.7282 12.5158ZM38.9852 19.5815C39.0353 19.7685 38.9243 19.9607 38.7373 20.0108C38.5502 20.061 38.358 19.95 38.3079 19.7629C38.2578 19.5759 38.3688 19.3837 38.5558 19.3336C38.7428 19.2835 38.9351 19.3944 38.9852 19.5815ZM37.3392 28.3281C37.3893 28.1411 37.2783 27.9488 37.0913 27.8987C36.9042 27.8486 36.712 27.9596 36.6619 28.1466C36.6118 28.3337 36.7228 28.5259 36.9098 28.576C37.0968 28.6261 37.2891 28.5151 37.3392 28.3281ZM38.9852 36.8935C39.0353 36.7064 38.9243 36.5142 38.7373 36.4641C38.5502 36.414 38.358 36.525 38.3079 36.712C38.2578 36.899 38.3688 37.0912 38.5558 37.1414C38.7428 37.1915 38.9351 37.0805 38.9852 36.8935ZM72.1057 19.5815C72.0556 19.7685 72.1665 19.9607 72.3536 20.0109C72.5406 20.061 72.7328 19.95 72.7829 19.763C72.8331 19.5759 72.7221 19.3837 72.535 19.3336C72.348 19.2835 72.1558 19.3945 72.1057 19.5815ZM73.7522 28.3282C73.7021 28.1412 73.8131 27.949 74.0001 27.8988C74.1871 27.8487 74.3793 27.9597 74.4295 28.1467C74.4796 28.3338 74.3686 28.526 74.1816 28.5761C73.9945 28.6262 73.8023 28.5152 73.7522 28.3282ZM72.1057 36.8934C72.0556 36.7064 72.1665 36.5142 72.3536 36.464C72.5406 36.4139 72.7328 36.5249 72.7829 36.7119C72.8331 36.899 72.7221 37.0912 72.535 37.1413C72.348 37.1914 72.1558 37.0804 72.1057 36.8934ZM46.0241 12.4251C46.161 12.562 46.383 12.562 46.5199 12.4251C46.6568 12.2882 46.6568 12.0662 46.5199 11.9293C46.383 11.7924 46.161 11.7924 46.0241 11.9293C45.8872 12.0662 45.8872 12.2882 46.0241 12.4251ZM64.4791 44.388C64.429 44.201 64.54 44.0088 64.727 43.9587C64.914 43.9085 65.1063 44.0195 65.1564 44.2066C65.2065 44.3936 65.0955 44.5858 64.9085 44.6359C64.7215 44.686 64.5292 44.5751 64.4791 44.388Z"
                        fill="#009EE0"/>
                  <path
                      d="M6.9873 65.0832C6.9873 64.8908 6.99053 64.6991 6.99691 64.5083H40.688C40.6943 64.6991 40.6976 64.8908 40.6976 65.0832C40.6976 74.392 33.1513 81.9383 23.8424 81.9383C14.5336 81.9383 6.9873 74.392 6.9873 65.0832Z"
                      stroke="#009EE0" stroke-width="2"/>
                </svg>
              </div>
              <p class="text">
                <span class="big">We are currently focusing on diverse therapy</span> areas such as Anesthesia, Contrast
                Media, Hormones, Urology and Infertility <span class="color">where we have the experience necessary to compete effectively.</span>
              </p>
            </div>
          </div>

        </div>
      </section>

      <section id="sales-marketing">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">Sales & Marketing</h2>
          <div class="item-wrapper">
            <div class="js-scroll fade-in-bottom item">
              <div class="icon">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M64.3599 17.1729C66.0757 18.3697 67.6753 19.7218 69.1383 21.2087" stroke="#009EE0"
                        stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M17.4516 34.3401C9.74647 34.3401 3.5 40.587 3.5 48.2917C3.5 59.6274 17.4516 72.707 17.4516 72.707C17.4516 72.707 31.4032 59.6274 31.4032 48.2917C31.4032 40.587 25.1568 34.3401 17.4516 34.3401ZM17.4516 52.9422C14.8831 52.9422 12.8011 50.86 12.8011 48.2917C12.8011 45.7235 14.8831 43.6412 17.4516 43.6412C20.0202 43.6412 22.1022 45.7235 22.1022 48.2917C22.1022 50.86 20.0202 52.9422 17.4516 52.9422Z"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M44.916 2.5C37.2108 2.5 30.9644 8.74689 30.9644 16.4516C30.9644 27.7873 44.916 40.867 44.916 40.867C44.916 40.867 58.8676 27.7873 58.8676 16.4516C58.8676 8.74689 52.6211 2.5 44.916 2.5ZM44.916 21.1022C42.3474 21.1022 40.2654 19.0199 40.2654 16.4516C40.2654 13.8834 42.3474 11.8011 44.916 11.8011C47.4845 11.8011 49.5665 13.8834 49.5665 16.4516C49.5665 19.0199 47.4845 21.1022 44.916 21.1022Z"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M72.5592 48.1331C64.854 48.1331 58.6075 54.3799 58.6075 62.0847C58.6075 73.4204 72.5592 86.5 72.5592 86.5C72.5592 86.5 86.5108 73.4204 86.5108 62.0847C86.5108 54.3799 80.2643 48.1331 72.5592 48.1331ZM72.5592 66.7352C69.9906 66.7352 67.9086 64.6529 67.9086 62.0847C67.9086 59.5164 69.9906 57.4341 72.5592 57.4341C75.1277 57.4341 77.2097 59.5164 77.2097 62.0847C77.2097 64.6529 75.1277 66.7352 72.5592 66.7352Z"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M12.0524 35.1628C14.8522 25.2637 22.0508 17.2116 31.4032 13.2515" stroke="#009EE0"
                        stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M62.1179 73.2524C57.0026 76.3682 50.9943 78.1631 44.5667 78.1631C35.5558 78.1631 27.3687 74.6355 21.3113 68.886"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M73.1699 26.3871C76.4531 31.5962 78.3526 37.7649 78.3526 44.3772C78.3526 46.0159 78.2359 47.6274 78.0104 49.2037"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M57.7301 22.081C61.2809 24.1819 64.2865 27.1069 66.4835 30.5926C68.9991 34.584 70.4546 39.3106 70.4546 44.3772C70.4546 45.7199 70.3524 47.0387 70.1553 48.3262"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                  <path d="M20.5382 34.7241C22.739 29.251 26.7555 24.7035 31.8419 21.8271" stroke="#009EE0"
                        stroke-width="2" stroke-miterlimit="10"/>
                  <path
                      d="M58.991 65.8775C54.869 68.6483 49.9066 70.2652 44.5666 70.2652C37.3549 70.2652 30.832 67.3163 26.1378 62.5587"
                      stroke="#009EE0" stroke-width="2" stroke-miterlimit="10"/>
                </svg>
              </div>
              <p class="text">
                <span class="big">We started by initiating a local presence in UAE</span>
                and we are expanding
                to other countries in the region soon.
              </p>
            </div>
          </div>

        </div>
      </section>

      <section id="contact" class="contact">
        <div class="content">
          <h2 class="js-scroll fade-in-bottom">
            <span class="line1">Contact us</span>
            <span class="line3">Farmak</span>
          </h2>
          <p class="js-scroll fade-in-bottom text">
            Farmak FZ-LLC<br>
            Office 909 N<br>
            Dubai Science Park Towers — North, Dubai<br>
            United Arab Emirates<br>
            0097145587038
          </p>

          <div class="info js-scroll fade-in-bottom">
            <div class="mark"></div>
            <div class="line">
              <p class="address">
                Farmak FZ-LLC, office 909&nbsp;N<br>
                Dubai Science Park Towers — North, Dubai, UAE
              </p>
              <a class="mail" href="mailto:office@farmak.ae">office@farmak.ae</a>
            </div>
          </div>
        </div>
      </section>

    </div>

    <div class="right-side">
      <div class="right-side__country-switch-wrapper">
        <p>Country</p>
        <div class="right-side__country-switch">
          <div @click="drop = !drop" class=" show" v-bind:class="[{ active: drop }]">UAE
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 10.6286L4 5.37138L12 5.37138L8 10.6286Z" fill="white"/>
            </svg>
          </div>
          <div class="hide" v-if="drop">
            <a @click="drop = false" href="https://www.farmak.co.cz/" target="_blank">Czechia</a>
            <a @click="drop = false" href="https://farmakinternational.pl/" target="_blank">Poland</a>
            <a @click="drop = false" href="https://farmak.sk/" target="_blank">Slovakia</a>
            <a @click="drop = false" href="https://farmak.es/" target="_blank">Spain</a>
            <a @click="drop = false" href="https://www.farmak.ch/" target="_blank">Switzerland</a>
            <a @click="drop = false" href="https://farmak.uk/" target="_blank">UK</a>
            <a @click="drop = false" href="https://farmak.ua/en/worldwide/" target="_blank">Ukraine</a>
          </div>
        </div>
      </div>
      <Transition>
        <picture v-if="getActiveLink ==='home'">
          <img src="@/assets/img/circle-img1.png" alt="">

        </picture>
      </Transition>

      <Transition>
        <picture v-if="getActiveLink ==='news'">
          <img src="@/assets/img/circle-img7.png" alt="">

        </picture>
      </Transition>

      <Transition>
        <picture v-if="getActiveLink ==='values'">
          <img src="@/assets/img/circle-img2.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='mea-region'">
          <img src="@/assets/img/circle-img3.png" alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='focus'">
          <img src="@/assets/img/circle-img4.png"
               alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='sales-marketing'">
          <img src="@/assets/img/circle-img5.png"
               alt="">
        </picture>
      </Transition>
      <Transition>
        <picture v-if="getActiveLink ==='contact'">
          <img src="@/assets/img/circle-img6.png"
               alt="">
        </picture>
      </Transition>
      <div class="right-side__info">
        <div class="mark" v-if="getActiveLink !=='contact'"></div>
        <div class="line" v-bind:class="[{ active: getActiveLink ==='contact'}]">
          <p class="address" v-if="getActiveLink !=='contact'">
            Farmak FZ-LLC, office 909 N<br>
            Dubai Science Park Towers — North, Dubai, UAE
          </p>
          <a v-bind:class="[{ active: getActiveLink ==='contact'}]" class="mail" href="mailto:office@farmak.ae">office@farmak.ae</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

import {mapActions, mapGetters} from "vuex";

export default {
  name: 'HomeView',

  computed: {
    ...mapGetters(['getActiveLink'])
  },

  data: () => ({
    drop: false
  }),

  methods: {
    ...mapActions(['switchLink']),

    next() {

      if (window.matchMedia("(min-width: 1080px)").matches) {
        window.scrollTo({
          top: document.getElementById('news').offsetTop - 79,
          left: 0,
          behavior: "smooth",
        });
      } else if (window.matchMedia("(max-width: 1079px)").matches) {
        window.scrollTo({
          top: document.getElementById('news').offsetTop - 64,
          left: 0,
          behavior: "smooth",
        });
      }
    },

  },

  mounted() {
    const headings = document.querySelectorAll('section');

    const scrollElements = document.querySelectorAll(".js-scroll");

    const elementInView = (el, dividend = 1) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
          elementTop <=
          (window.innerHeight || document.documentElement.clientHeight) / dividend
      );
    };

    const elementOutofView = (el) => {
      const elementTop = el.getBoundingClientRect().top;

      return (
          elementTop > (window.innerHeight || document.documentElement.clientHeight)
      );
    };

    const displayScrollElement = (element) => {
      element.classList.add("scrolled");
    };

    const hideScrollElement = (element) => {
      element.classList.remove("scrolled");
    };

    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 1.1)) {
          displayScrollElement(el);
        } else if (elementOutofView(el)) {
          hideScrollElement(el)
        }
      })
    }
    if (window.matchMedia("(min-width: 861px)").matches) {
      window.addEventListener("scroll", () => {

        handleScrollAnimation()

        headings.forEach(ha => {
          const rect = ha.getBoundingClientRect();

          if (rect.top + 200 < window.innerHeight && rect.bottom - 200 >= 0) {
            const location = window.location.toString().split('#')[0];
            this.switchLink(ha.id);
            history.replaceState(null, null, location + '#' + ha.id);
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/styles";

.js-scroll {
  opacity: 0;
  @media screen and (max-width: 1024px) {
    opacity: 1;
  }
}

.scrolled.fade-in-bottom {
  animation: fade-in-bottom .6s ease-in-out both;

  &.delay-fade1 {
    animation-delay: .5s;
  }

  &.delay-fade2 {
    animation-delay: .6s;
  }

  &.delay-fade3 {
    animation-delay: 1200ms;
  }

  &.delay-fade4 {
    animation-delay: 1400ms;
  }

  &.delay-fade5 {
    animation-delay: 1500ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 900ms;
  }

  &.delay-width2 {
    animation-delay: 1000ms;
  }

  &.delay-width3 {
    animation-delay: 1100ms;
  }

  &.delay-width4 {
    animation-delay: 1200ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.width-animation2 {
  animation: width-animation .6s ease-in-out both;

  &.delay-width1 {
    animation-delay: 100ms;
  }

  &.delay-width2 {
    animation-delay: 200ms;
  }

  &.delay-width3 {
    animation-delay: 300ms;
  }

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

.scrolled.rotate-animation {
  animation: rotate-animation .8s ease-in-out both;

  @media screen and (max-width: 1024px) {
    animation: none;
  }
}

@keyframes fade-in-bottom {
  0% {
    transform: translateY(30px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes width-animation {
  0% {
    width: 0;
    opacity: 0;
  }
  100% {
    width: 100%;
    opacity: 1;
  }
}

@keyframes rotate-animation {
  0% {
    opacity: 0;
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}

.home {
  display: flex;
  justify-content: center;
  width: 100%;

  .left-side {
    max-width: 50%;
    min-width: 50%;
    width: 100%;

    @media screen and (max-width: 1080px) {
      max-width: 100%;
      min-width: 1px;
    }
  }

  .right-side {

    display: flex;
    flex-direction: column;

    max-width: 50%;
    min-width: 50%;
    width: 100%;

    position: sticky;
    position: -webkit-sticky;
    top: 0;
    left: 0;
    min-height: calc((var(--vh, 1vh) * 100));
    max-height: calc((var(--vh, 1vh) * 100));
    height: 100%;
    background: $blue-50;

    padding: 0 40px;

    @media screen and (max-width: 1080px) {
      display: none;
    }

    .wrapper {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      max-height: 680px;
      width: 100%;

      .text-block {
        position: absolute;
        bottom: 115px;
        padding: 10px;
        background: $blue-80;
        max-width: 208px;

        width: 100%;

        line-height: 120%; /* 19.2px */
        text-transform: uppercase;
        font-family: $reg;
        font-size: 16px;
        color: white;
        @media screen and (max-height: 750px) {
          bottom: 160px;
        }


        &.text-block1 {
          left: 40px;
        }

        &.text-block2 {
          right: 40px;
        }
      }
    }

    picture {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: auto 0;
      max-width: 680px;
      width: 100%;

      img {
        //position: absolute;
        //top: 50%;
        //left: 50%;
        //
        //transform: translate(-50%, -50%);
        margin-top: -60px;
        max-height: 680px;
        min-width: 1px;
        width: auto;
        height: 100%;
        display: block;
        padding: 40px;
        object-fit: contain;
        overflow: visible;
        @media screen and (max-height: 750px) {
          margin-top: 0;
        }
      }
    }

    &__info {
      margin: auto 0 0 0;
      max-width: 600px;
      width: 100%;
      background: rgba(0, 158, 224, 0.50);
      padding-top: 10px;
      padding-bottom: 44px;
      position: relative;

      .mark {
        width: 16px;
        height: 16px;

        background: $crimson;
        border-radius: 50%;
        margin-bottom: 15px;
      }

      .line {
        width: 100%;
        padding-bottom: 16px;
        margin-bottom: 24px;
        border-bottom: 2px solid $white;

        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        &.active {
          justify-content: center;
        }

        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          margin-bottom: 0;
        }
      }

      .address {
        color: $white;
        font-size: 16px;
        font-family: $bold;
        line-height: 120%;
        //letter-spacing: -0.04em;
        margin-right: 15px;
      }

      .mail {
        border: 2px solid rgba(255, 255, 255, 0);
        transition: border-color .2s ease;
        border-radius: 44px;
        padding: 17px 35px;

        text-decoration: none;
        color: $white;
        font-size: 12px;
        font-family: $bold;
        text-transform: uppercase;
        background: rgba(255, 255, 255, 0.2);

        letter-spacing: -0.02em;

        height: 52px;

        display: flex;
        justify-content: center;
        align-items: center;

        &.active {
          font-size: 22px;
          height: 66px;
          padding: 22px 40px;

        }

        @media screen and (max-width: 1280px) {
          padding: 12px 20px;
          height: 48px;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            border-color: $white;
          }
        }
      }

      .sales-mail {
        position: relative;
        font-size: 18px;
        line-height: 120%;
        font-family: $bold;
        color: $white;

        display: inline-flex;
        align-items: center;
        text-decoration: none;
        //letter-spacing: -0.04em;
        p {
          display: flex;
          align-items: center;
          transition: transform .2s ease;
        }

        @media screen and (min-width: 1240px) {
          &:hover {
            p {
              transform: translateY(-2px);
            }
          }
        }

        svg {
          display: block;
          width: 21px;
          height: auto;
          margin-left: 10px;
        }

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          bottom: -4px;
          left: 0;
          right: 0;
          position: absolute;

          background: $white;
        }
      }
    }

    &__country-switch-wrapper {
      max-width: 600px;
      position: absolute;
      width: 100%;
      left: 0;
      top: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      z-index: 10;

      p {
        line-height: 136%;
        font-family: $bold;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.6);
        text-transform: uppercase;
        padding: 4px 6px;
      }
    }

    &__country-switch {
      position: relative;

      .show {
        color: white;
        font-size: 12px;
        line-height: 136%;
        font-family: $bold;
        text-transform: uppercase;
        padding: 8px 12px;
        min-width: 110px;

        display: flex;
        align-items: center;
        cursor: pointer;

        &.active {
          color: $black-100;
          background: rgba(255, 255, 255, 1);

          svg {
            transform-origin: center;
            transform: rotate(180deg);

            path {
              fill: $black-100;
            }
          }
        }

        svg {
          display: block;
          width: 16px;
          height: auto;
          margin-left: 9px;
        }
      }

      .hide {
        position: absolute;
        top: 100%;
        left: 0;

        display: flex;
        flex-direction: column;
        background: #26ADE5;
        width: 100%;

        a {
          padding: 8px 12px;
          text-transform: uppercase;

          text-decoration: none;
          color: white;
          font-size: 12px;
          font-family: $bold;
          line-height: 136%;

          @media screen and (min-width: 1240px) {
            &:hover {
              background: rgba(255, 255, 255, 0.30);
            }
          }
        }
      }
    }
  }
}

#home {
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 78px 40px 0 40px;
  background: $black-10;

  @media screen and (max-width: 1080px) {
    min-height: calc(((var(--vh, 1vh) * 100) - 64px));
    align-items: center;
    padding: 62px 0 0 0;
  }

  .bg {
    display: none;
    background: $blue-50;
    margin: 0 -20px;
    width: 100%;
    max-height: calc(((var(--vh, 1vh) * 30)));
    height: 100%;
    overflow: hidden;
    position: relative;

    img {
      display: block;
      width: calc(100% - 40px);
      height: 100%;
      margin-top: 50px;
      max-height: calc(((var(--vh, 1vh) * 48)));
      object-fit: contain;
    }

    @media screen and (max-width: 1080px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(((var(--vh, 1vh) * 100) - 174px));
    max-width: 600px;
    width: 100%;

    @media screen and (max-width: 1080px) {
      max-width: 420px;
      padding: 20px 20px 0 20px;
      min-height: calc(((var(--vh, 1vh) * 70) - 171px));
    }
  }

  .scroll-down {
    color: $blue-50;
    font-family: $bold;
    font-size: 12px;
    margin: auto 0 40px 0;
    padding-top: 40px;

    display: flex;
    align-items: center;
    cursor: pointer;

    max-width: 600px;
    width: 100%;

    text-transform: uppercase;
    transition: color .2s ease;

    @media screen and (max-width: 1080px) {
      margin: auto 0 60px 0;
      padding: 33px 20px 0 20px;
      max-width: 380px;
    }

    @media screen and (min-width: 1240px) {
      &:hover {
        color: $blue-80;

        svg {
          path {
            fill: $blue-80;
          }
        }
      }
    }

    svg {
      width: 12px;
      height: auto;
      display: block;
      margin-right: 12px;

      path {
        transition: fill .2s ease;
      }
    }
  }

  h1 {
    color: $blue-50;
    font-family: $bold;
    letter-spacing: -0.04em;

    span {
      display: inline-block;

      &.small {
        font-size: 80px;
        line-height: 78%;
        min-width: 277px;
        width: 100%;
        display: inline-block;

        @media screen and (max-width: 1180px) {
          font-size: 70px;
          min-width: 247px;
        }

        @media screen and (max-width: 1080px) {
          font-size: 40px;
        }

        &.m-l {
          margin-left: 20px;
          @media screen and (max-width: 1230px) {
            margin-left: 16px;
          }
        }
      }

      &.big {
        font-size: 135px;
        line-height: 78%;
        text-transform: uppercase;
        margin-bottom: 8px;

        @media screen and (max-width: 1360px) {
          font-size: 120px;
        }
        @media screen and (max-width: 1180px) {
          font-size: 100px;
        }

        @media screen and (max-width: 1080px) {
          font-size: 64px;
        }
      }

      &.bottom {
        display: flex;
        align-items: center;
      }

      &.line-wrapper {
        max-width: 258px;
        width: 100%;
        display: flex;
        margin-left: 10px;
        flex-direction: column;

        @media screen and (max-width: 1230px) {
          max-width: 60%;
        }

        @media screen and (max-width: 1080px) {
          margin-left: 4px;
        }

        > span {
          width: 100%;
          margin-bottom: 7px;
          background: $blue-50;
          @media screen and (max-width: 1080px) {
            margin-bottom: 3px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &.line1 {
        height: 16px;
        @media screen and (max-width: 1080px) {
          height: 8px;
        }
      }

      &.line2 {
        height: 10px;
        @media screen and (max-width: 1080px) {
          height: 5px;
        }
      }

      &.line3 {
        height: 5px;
        @media screen and (max-width: 1080px) {
          height: 2px;
        }
      }

      &.line4 {
        height: 2px;
        @media screen and (max-width: 1080px) {
          height: 1px;
        }
      }
    }
  }

  h2 {
    color: $black-80;
    font-family: $bold;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: -0.04em;
    margin-top: 24px;
    @media screen and (max-width: 1230px) {
      font-size: 24px;
    }
    @media screen and (max-width: 1080px) {
      font-size: 18px;
    }

    .mr1 {
      margin-right: 40px;
      @media screen and (max-width: 1230px) {
        margin-right: 20px;
      }
    }

    .mr2 {
      margin-right: 90px;
      @media screen and (max-width: 1230px) {
        margin-right: 50px;
      }
    }

    //@media screen and (max-width: 1280px) {
    //  font-size: 28px;
    //}
    //
    //@media screen and (max-width: 1080px) {
    //  font-size: 18px;
    //}

    .color {
      color: $blue-60;
    }
  }

  h3 {
    margin: 4px 30px 0 auto;
    color: $black-100;
    line-height: 120%;
    font-size: 18px;
    font-family: $bold;
    @media screen and (max-width: 1300px) {
      margin: 4px 0 0 auto;

    }
    @media screen and (max-width: 1080px) {
      font-size: 14px;
    }
  }
}

#values {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: #F1F1F1;

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      padding-bottom: 60px;

      max-width: 380px;
    }
  }

  h2 {
    color: $black-60;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 49px;
    @media screen and (max-width: 1080px) {
      margin-bottom: 24px;
      font-size: 24px;
    }
  }

  .button-wrapper {
    transition: transform .2s ease;
    margin-bottom: 240px;

    @media screen and (max-width: 1080px) {
      margin-bottom: 120px;

    }
    @media screen and (min-width: 1080px) {
      &:hover {
        transform: scale(.83);
      }
    }


    .item {
      margin-top: -1px;
      border: 1px solid var(--blue-50, #009EE0);
      padding: 16px 24px;
      display: flex;
      align-items: center;

      cursor: pointer;
      transform-origin: center;

      transition: transform .2s ease;
      background: #F1F1F1;
      overflow: hidden;
      position: relative;

      @media screen and (max-width: 1080px) {
        padding: 12px 24px;
      }

      &:before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 59.16%, rgba(38, 173, 229, 0.17) 100%);

      }

      @media screen and (min-width: 1240px) {
        &:hover {

          &.item5 {
            transform: scale(1.20);
            z-index: 3;
          }

          &.item4 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item5 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item3 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item4 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item2 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item3 {
              transform: scale(1.1);
              z-index: 2;
            }
          }

          &.item1 {
            transform: scale(1.20);
            z-index: 3;

            & ~ .item2 {
              transform: scale(1.1);
              z-index: 2;
            }
          }
        }

        &:has(+ .item:hover) {
          transform: scale(1.1);
          z-index: 2;
        }
      }

      &:first-child {
        margin-top: 0
      }

      svg {
        display: block;
        width: 33px;
        height: auto;
        margin-right: 24px;
      }

      p {
        font-size: 32px;
        font-family: $bold;
        line-height: 110%;
        color: $blue-60;
        @media screen and (max-width: 1080px) {
          font-size: 20px;
        }
      }
    }
  }

  .our-mission {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      background: $blue-50;
      width: 100%;
      margin: 4px 0;


      &.line1 {
        height: 12px;
        max-width: calc(100% - 100px);

        margin-top: 8px;

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);

        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 2px;
        max-width: calc(100% - 200px);
        margin-bottom: 0;
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }
    }

    .blue {
      background: $blue-50;
      padding: 60px;
      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        text-transform: uppercase;
        font-size: 44px;
        font-family: $bold;
        color: white;
        line-height: 120%;
        margin-bottom: 24px;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: white;
        line-height: 120%;

        @media screen and (max-width: 1080px) {
          font-size: 16px;

        }
      }
    }
  }

  .purpose {
    display: flex;
    flex-direction: column;
    align-items: center;

    .line {
      background: white;
      width: 100%;
      margin: 4px 0;

      &.line1 {
        margin-top: 0;

        height: 2px;
        max-width: calc(100% - 200px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 104px);
        }
      }

      &.line2 {
        height: 6px;
        max-width: calc(100% - 150px);
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 76px);
        }
      }

      &.line3 {
        height: 12px;
        max-width: calc(100% - 100px);
        margin-bottom: 8px;
        @media screen and (max-width: 1080px) {
          max-width: calc(100% - 50px);
        }
      }
    }

    .white {
      background: white;
      padding: 80px 60px;

      @media screen and (max-width: 1080px) {
        padding: 32px;
      }

      h3 {
        font-size: 44px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        margin-bottom: 24px;
        letter-spacing: -1.76px;

        @media screen and (max-width: 1080px) {
          letter-spacing: -1.28px;
          font-size: 32px;
        }
      }

      p {
        font-size: 20px;
        font-family: $bold;
        color: #231F20;
        line-height: 120%;
        letter-spacing: -0.8px;
        @media screen and (max-width: 1080px) {
          letter-spacing: -0.64px;
          font-size: 16px;
        }
      }
    }
  }
}

#mea-region {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 40px;
    text-transform: uppercase;
    letter-spacing: -1.6px;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 50px 60px;
      background: #F1F1F1;
      display: flex;
      flex-direction: column;
      margin-bottom: 4px;
      @media screen and (max-width: 1240px) {
        padding: 24px 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 90px;
        min-width: 90px;
        width: 100%;
        margin-right: 24px;
        margin-bottom: 16px;
        @media screen and (max-width: 1240px) {
          max-width: 80px;
          min-width: 80px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .text {
        color: #231F20;
        font-size: 20px;
        line-height: 120%;
        font-family: $bold;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        .color {
          color: #038FD0;
        }

        .big {
          letter-spacing: -0.72px;
          font-size: 24px;
          color: #038FD0;
          text-transform: uppercase;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
            letter-spacing: 0;
          }
        }
      }
    }
  }
}

#focus {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 40px;
    letter-spacing: -1.6px;
    text-transform: uppercase;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 50px 60px;
      background: #F1F1F1;
      display: flex;
      flex-direction: column;
      margin-bottom: 4px;
      @media screen and (max-width: 1240px) {
        padding: 24px 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 90px;
        min-width: 90px;
        width: 100%;
        margin-right: 24px;
        margin-bottom: 16px;
        @media screen and (max-width: 1240px) {
          max-width: 80px;
          min-width: 80px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .text {
        color: #231F20;
        font-size: 20px;
        line-height: 120%;
        font-family: $bold;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        .color {
          color: #038FD0;
        }

        .big {
          font-size: 24px;
          color: #038FD0;
          text-transform: uppercase;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
          }
        }
      }
    }
  }
}

#sales-marketing {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }
  }

  h2 {
    color: #63666A;
    font-size: 32px;
    font-family: $bold;
    margin-bottom: 40px;
    letter-spacing: -1.6px;
    text-transform: uppercase;
    @media screen and (max-width: 1080px) {
      font-size: 24px;
    }
  }

  .item-wrapper {
    display: flex;
    flex-direction: column;

    .item {
      padding: 50px 60px;
      background: #F1F1F1;
      display: flex;
      flex-direction: column;
      margin-bottom: 4px;
      @media screen and (max-width: 1240px) {
        padding: 24px 20px;
      }

      &:last-child {
        margin-bottom: 0;
      }

      .icon {
        max-width: 90px;
        min-width: 90px;
        width: 100%;
        margin-right: 24px;
        margin-bottom: 16px;
        @media screen and (max-width: 1240px) {
          max-width: 80px;
          min-width: 80px;
        }

        svg {
          width: 100%;
          height: auto;
          display: block;
        }
      }

      .text-wrapper {
        display: flex;
        align-items: center;

        @media screen and (max-width: 1080px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .text {
        color: #231F20;
        font-size: 20px;
        line-height: 120%;
        font-family: $bold;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }

        .color {
          color: #038FD0;
        }

        .big {
          font-size: 24px;
          color: #038FD0;
          text-transform: uppercase;
          @media screen and (max-width: 1080px) {
            font-size: 20px;
          }
        }
      }
    }
  }
}

#contact {
  padding: 0 40px;

  display: flex;
  justify-content: flex-end;

  background: $blue-50;

  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .content {
    max-width: 600px;
    width: 100%;
    padding-top: 79px;
    padding-bottom: 40px;

    display: flex;
    flex-direction: column;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      padding-bottom: 20px;
      max-width: 380px;
    }

    h2 {
      display: block;
      color: white;
      margin: auto 0;
      font-family: $bold;

      @media screen and (max-width: 1080px) {
        margin: 0 0 80px 0;
      }

      span {
        display: flex;
      }

      .line1 {
        display: block;
        margin-bottom: 16px;
        margin-left: 8px;
        font-size: 32px;

        letter-spacing: -1.6px;
        text-transform: uppercase;

        @media screen and (max-width: 1080px) {
          font-size: 28px;
          margin-bottom: 14px;
          letter-spacing: -1.4px;
          margin-left: 0;
        }
      }

      .line2 {
        font-size: 80px;
        line-height: 78%;
        letter-spacing: -3.2px;
        text-transform: uppercase;
        @media screen and (max-width: 1080px) {
          font-size: 32px;
          margin-bottom: 4px;
          letter-spacing: -1.28px;
        }
      }

      .line3 {
        font-size: 120px;
        line-height: 78%;
        letter-spacing: -4.8px;
        text-transform: uppercase;
        @media screen and (max-width: 1080px) {
          font-size: 64px;
          letter-spacing: -2.56px;


        }
      }

      .line4 {
        font-size: 80px;
        line-height: 78%;
        letter-spacing: -3.2px;
        text-transform: uppercase;

        justify-content: flex-end;

        @media screen and (max-width: 1080px) {
          font-size: 32px;
          letter-spacing: -1.28px;


        }
      }

      .line5 {
        font-size: 20px;
        line-height: 100%; /* 20px */
        letter-spacing: -0.8px;
        justify-content: flex-end;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
          letter-spacing: -0.64px;

        }
      }
    }

    .text {
      line-height: 120%;

      font-family: $bold;
      color: $white;
      font-size: 20px;
      letter-spacing: -0.4px;
      margin: auto 0 0 8px;

      @media screen and (max-width: 1080px) {
        font-size: 16px;
        margin-bottom: 26px;
        margin-left: 0;
      }
    }
  }

  .info {
    margin: auto 0 0 0;
    max-width: 600px;
    width: 100%;
    background: $blue-50;
    position: relative;
    display: none;

    @media screen and (max-width: 1080px) {
      display: block;
    }

    .mark {
      width: 12px;
      height: 12px;

      background: $crimson;
      border-radius: 50%;
      margin-bottom: 7px;

      @media screen and (max-width: 1080px) {
        display: none;
      }
    }

    .line {
      width: 100%;
      padding-bottom: 32px;
      margin-bottom: 32px;
      border-bottom: 2px solid $white;

      display: flex;
      justify-content: space-between;

      @media screen and (max-width: 500px) {
        flex-direction: column;
      }

      &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
        margin-bottom: 0;
      }
    }

    .address {
      color: $white;
      font-size: 15px;
      font-family: $bold;
      line-height: 120%;
      //letter-spacing: -0.04em;
      margin-right: 15px;

      @media screen and (max-width: 1080px) {
        display: none;
      }
      @media screen and (max-width: 500px) {
        margin-right: 0;
        margin-bottom: 15px;
      }
    }

    .mail {
      border: 2px solid #009EE0;
      background: rgba(255, 255, 255, 0.20);

      transition: border-color .2s ease;
      border-radius: 44px;
      padding: 17px 35px;

      text-decoration: none;
      color: $white;
      font-size: 12px;
      font-family: $bold;
      text-transform: uppercase;

      letter-spacing: -0.02em;

      height: 52px;

      display: flex;
      justify-content: center;
      align-items: center;

      @media screen and (max-width: 1280px) {
        padding: 12px 20px;
        height: 48px;
      }

      @media screen and (max-width: 1080px) {
      }

      @media screen and (min-width: 1240px) {
        &:hover {
          border-color: $white;
        }
      }
    }

    .sales-mail {
      position: relative;
      font-size: 15px;
      line-height: 120%;
      font-family: $bold;
      color: $white;

      display: inline-flex;
      align-items: center;
      text-decoration: none;
      //letter-spacing: -0.04em;

      p {
        display: flex;
        align-items: center;
        transition: transform .2s ease;
      }

      @media screen and (min-width: 1240px) {
        &:hover {
          p {
            transform: translateY(-2px);
          }
        }
      }

      svg {
        display: block;
        width: 14px;
        height: auto;
        margin-left: 10px;
      }

      &:before {
        content: '';
        width: 100%;
        height: 2px;
        bottom: -4px;
        left: 0;
        right: 0;
        position: absolute;

        background: $white;
      }
    }
  }
}

#news {
  padding: 0 40px;
  display: flex;
  justify-content: flex-end;
  background: white;
  min-height: calc(((var(--vh, 1vh) * 100) - 79px));

  @media screen and (max-width: 1080px) {
    justify-content: center;
    padding: 0 20px;
    min-height: 0;
  }

  .news {
    max-width: 600px;
    width: 100%;
    padding-top: 120px;
    padding-bottom: 120px;
    margin: auto 0;

    @media screen and (max-width: 1080px) {
      padding-top: 60px;
      max-width: 380px;
      padding-bottom: 60px;
    }

    &__title {
      color: var(--Crimson, #EB305D);
      font-family: $bold;
      font-size: 32px;
      font-style: normal;
      line-height: 100%;
      letter-spacing: -1.6px;
      text-transform: uppercase;
      margin-bottom: 30px;

      @media screen and (max-width: 1080px) {
        font-size: 28px;
      }
    }

    &__subTitle {
      color: #231F20;
      font-family: $bold;
      font-size: 22px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 26.4px */
      margin-bottom: 32px;

      @media screen and (max-width: 1080px) {
        font-size: 18px;
      }

      &--mt {
        margin-top: 72px;
      }

      &--arabic {
        text-align: right;
        font-family: "Rubik", sans-serif;
        font-weight: 700;
      }
    }

    &__text {
      color: #231F20;
      font-family: $reg;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 21.6px */
      margin-bottom: 15px;
      @media screen and (max-width: 1080px) {
        font-size: 16px;
      }

      a {
        color: var(--Blue-60, #038FD0);
        font-family: $bold;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%;
        text-decoration: none;
        @media screen and (max-width: 1080px) {
          font-size: 16px;
        }
        @media screen and (min-width: 1024px) {
          &:hover {
            text-decoration: underline;
          }
        }

        &:active {
          text-decoration: underline;
        }

      }

      &--last {
        margin-bottom: 0;
      }

      &--arabic {
        font-family: "Rubik", sans-serif;
        font-weight: 400;
        text-align: right;
      }
    }
  }
}

</style>
